import { FC, useCallback, useState } from 'react';
import { StudentEventsViewProps } from './studentEvents.interfaces';
import { useStudentEventsState, useStudentEventsActions } from '../../contexts/studentEvents.context';
import { Box } from '@mui/material';
import CalendarComponent from '../../../../components/calendarComponent/calendarComponent';
import { EventClickArg } from '@fullcalendar/core';
import AddEventComponent from '../../../../components/addEventComponent/addEventComponent.view';
import { TEventsPrimary } from '../../../../../apis/events/events.interfaces';
import { useTranslation } from '../../../../../hooks/useTranslationHook';
import { PermissionGate } from '../../../../../components/rbac/PermissionGate';
import { RbacDeniedRedirect } from '../../../../../components/rbac/RbacDeniedRedirect';

const StudentEventsView: FC<StudentEventsViewProps> = () => {
  const { translateText } = useTranslation();
  const { filteredEvents: studentBatchEvents } = useStudentEventsState();
  const { setCurrentMonth } = useStudentEventsActions();
  const [isAddEventModalOpen, setIsAddEventModalOpen] = useState(false);

  const handleMonthChange = useCallback((startDate: Date) => {
    const yyyy = startDate.getFullYear();
    const mm = String(startDate.getMonth() + 1).padStart(2, '0');
    setCurrentMonth(`${yyyy}-${mm}`);
  }, [setCurrentMonth]);

  const eventsForCalendar = studentBatchEvents.map((eachEvent) => ({
    title: eachEvent.title,
    date: eachEvent.startDate,
  }));

  const handleDateClick = (date: Date) => {
    console.log('Date clicked: ' + date);
    setIsAddEventModalOpen(true);
  };

  const handleEventClick = (event: EventClickArg) => {
    console.log('Event clicked: ' + event.event.title);
    setIsAddEventModalOpen(true);
  };

  const handleCloseAddEventModal = () => {
    setIsAddEventModalOpen(false);
  };

  const handleSubmitAddEvent = (event: Partial<TEventsPrimary>) => {
    console.log('Event submitted: ' + event.title);
  };

  return (
    <PermissionGate
      module="students"
      submodule="events"
      permission="read"
      fallback={<RbacDeniedRedirect />}
    >
      <Box
        data-testid="student-events-view"
        sx={{
          px: { xs: 1, sm: 2 },
          pt: { xs: 1, sm: 2 },
          pb: { xs: 2, sm: 4 },
        }}
      >
        <CalendarComponent
          events={eventsForCalendar}
          onDateClick={handleDateClick}
          onEventClick={handleEventClick}
          onMonthChange={handleMonthChange}
        />
        <AddEventComponent
          isOpen={isAddEventModalOpen}
          onClose={handleCloseAddEventModal}
          onSubmit={handleSubmitAddEvent}
          title={translateText('students.events.addEvent')}
          description={translateText('students.events.addNewEvent')}
          eventDetails={null}
          isLoading={false}
          errorMessage=""
        />
      </Box>
    </PermissionGate>
  );
};

export default StudentEventsView;
